export class CameraListProvider {
    public fromStorage() {
        const cameraListRaw = sessionStorage.getItem("scan_ship_camera_list");
        if (!cameraListRaw) {
            return undefined;
        }

        return JSON.parse(cameraListRaw) as MediaDeviceInfo[];
    }

    public async fromNavigator() {
        const stream = await navigator.mediaDevices.getUserMedia({
            video: {
                facingMode: {
                    ideal: "environment",
                },
            },
        });

        const cameraList = (await navigator.mediaDevices.enumerateDevices())
            .filter(d => d.kind === "videoinput");

        if (cameraList.length === 0) {
            return undefined;
        }

        stream.getTracks().forEach(track => {
            track.stop();
        });

        return [...cameraList.filter(d => !d.label.match(/front/i)),
            ...cameraList.filter(d => d.label.match(/front/i))];
    }

    public reset() {
        sessionStorage.removeItem("scan_ship_camera");
        sessionStorage.removeItem("scan_ship_camera_list");
    }
}
